module.exports = __webpack_public_path__ + "static/media/Slide36.61943778.JPG";